import * as React from 'react';
import useCategory from '../hooks/useCategory';
import { ICategory } from '../types';

type CategoryFunction = (data: ICategory) => React.ReactNode;

type CategoryProps = {
  children: CategoryFunction;
};

export const Category = ({ children }: CategoryProps) => {
  const category = useCategory();
  if (!category) return null;
  return <>{children(category)}</>;
};
